<template>
  <div>
    <span class="sr-only">{{ getAriaText(params) }}</span>
    <c-volume v-if="!params.node.group" :volume="volume" />
  </div>
</template>

<script>
import CVolume from '@custom/CVolume';
import { getAriaText } from '@utils/helpers';
export default {
  name: 'volume-renderer',
  components: {
    CVolume
  },
  data() {
    return {
      volume: {
        value: null,
        pct: null,
        direction: null
      }
    };
  },
  mounted() {
    this.volume.value = this.params.value;
    this.volume.pct = (100 / this.params.data['max_' + this.params.colDef.field]) * this.params.value;
    this.volume.direction = this.params.colDef.field === 'bid_size' ? 'rightJustified' : 'leftJustified';
  },
  methods: {
    getAriaText,
    refresh(params) {
      this.params = params;
      this.volume.value = params.value;
      this.volume.pct = (100 / params.data['max_' + params.colDef.field]) * params.value;
      this.volume.direction = params.colDef.field === 'bid_size' ? 'rightJustified' : 'leftJustified';
      return true;
    }
  }
};
</script>
